<template src="./ModalDeliveryCommentComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {ref, watch, computed, reactive} from "vue";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import InputTextareaNormal from "@/components/inputs/input-textarea/normal/InputTextareaNormal.vue";
import IconEdit from "@/components/icons/IconEdit.vue";
import IconTrash from "@/components/icons/IconTrash.vue";
import InputCheckboxOne from "@/components/inputs/input-checkbox/normal/InputCheckboxNormal.vue";
import PaginateComponent from "@/components/paginate/PaginateComponent.vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import ButtonBackComponent from "@/components/buttons/button-back/ButtonBackComponent.vue";
import CommonService from "@/services/common.service";
import {AppConstant} from "@/supports/app.constant";
import {useCommentStore} from "@/stores/comment.js";
export default {
  name: 'ModalDeliveryCommentComponent',
  components: {
    ButtonBackComponent,
    PaginateComponent,
    InputCheckboxOne,
    IconTrash, IconEdit,
    InputTextareaNormal,
    ButtonAddComponent,
    IconEye,
    LabelStatus,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome,
  },
  props: {
    showModalProduct: {
      type: Boolean,
      required: false,
      default: () => false
    },
    eventClickShowModal: {
      type: Boolean,
      required: false,
      default: () => false
    },
    accountComment: {
      type: Object,
      required: false,
      default: () => {}
    },
    deliveryId: {
      type: Number,
      required: true,
      default: () => 0
    },
    partnerId: {
      type: Number,
      required: true,
      default: () => 0
    }
  },
  emits: ['showModalComment', 'newComment', 'listProductsSelectedCurrent'],
  setup(props, { emit }) {
    const account = ref(props.accountComment)
    const deliveryId = ref(0)
    const partnerId = ref(0)

    const commentStore = useCommentStore()
    const comment = reactive({
      editor: ClassicEditor,
      editorData: '',
      editorConfig: {
        placeholder: 'Hãy bình luận về dữ liệu giao hàng để đối tác hiểu được mong muôn của bạn.'
      }
    })
    // bind event click show modal to call api get list product
    watch(() => props.eventClickShowModal, (eventClickShowModal) => {
      emit('showModalComment', true)
    })

    watch(() => props.deliveryId, (newDeliveryId) => {
      deliveryId.value = newDeliveryId
    })

    watch(() => props.partnerId, (newPartnerId) => {
      partnerId.value = newPartnerId
    })

    watch(() => commentStore.comment, (newComment) => {
      emit('newComment', {
        ...newComment,
        company: {
          company_name: account.value.company_name
        },
        user: {
          user_name: account.value.user_name
        }
      })
    })

    async function sendCommentDelivery() {
      if(validateFormComment()) {
        const params = {
          t_delivery_id: deliveryId.value,
          m_user_id: CommonService.getUserId(),
          m_company_id: CommonService.getCompanyId(),
          partner_id: partnerId.value,
          content: comment.editorData,
        }
        const url = AppConstant.URL_API_LOCAL + 'api/v1/comments/create-comment';
        await commentStore.createComment(url, params);
        emit('showModalComment', false)

        await CommonService.showAlertPopup({
          title: 'Bạn đã bình luận thành công!',
          icon: 'success',
          showConfirmButton: false,
          showCancelButton: false,
          timer: 1500,
          width: '800px'
        })
      }
    }

    function validateFormComment() {
      if(comment.editorData.trim() === '') {
        CommonService.showAlertPopup({
          title: 'Hãy để lại bình luận cho chúng tôi nhé!',
          icon: 'warning',
          showConfirmButton: false,
          showCancelButton: false,
          timer: 1500,
          width: '800px'
        })

        return false
      }
      if(parseInt(deliveryId.value) <= 0) {
        CommonService.showAlertPopup({
          title: 'Vui lòng chon đúng thông tin phiếu dữ liệu giao hàng!',
          icon: 'error',
          showConfirmButton: false,
          showCancelButton: false,
          timer: 1500,
          width: '800px'
        })

        return false
      }

      return true
    }

    function cancelComment() {

    }

    return {
      account,
      comment,
      sendCommentDelivery,
      cancelComment,

    }
  },
}
</script>
<style lang="scss">
  .ck-editor__editable {
    min-height: 300px;
  }
  .swal2-container{
    z-index: 1000000;
  }
</style>
